import { Grid, IconButton, IconName, Typography, NestedCard, Stack, StackItem } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import { DnsRecord } from '@mews-commander/data-access';
import { copyInputToClipboard } from '@mews-commander/utils';

export const DnsRecordList = ({ records }: { records: DnsRecord[] }) => (
    <Grid templateColumns="repeat(auto-fit, minmax(300px, 1fr))">
        {records.map((record) => (
            <DnsRecordView key={`${record.type}-${record.host}-${record.value}`} record={record} />
        ))}
    </Grid>
);

const DnsRecordView = ({ record }: { record: DnsRecord }) => (
    <NestedCard>
        <Stack vertical spacing="100">
            <Typography textStyle="bodyMediumStrong" as="div">
                {record.type}
            </Typography>
            <Stack vertical spacing="25">
                <DnsRecordRow labelTextKey={TextKey.DnsHost} value={record.host} />
                <DnsRecordRow labelTextKey={TextKey.DnsValue} value={record.value} />
            </Stack>
        </Stack>
    </NestedCard>
);

const DnsRecordRow = ({ labelTextKey, value }: { labelTextKey: Mews.TextKey; value: string }) => (
    <Stack itemAlignment="center" spacing="100">
        <Typography textStyle="bodyMediumStrong" variant="secondary" as="div">
            <LocalizedText textKey={labelTextKey} />
            {UnicodeEntity.Colon}
        </Typography>
        <StackItem>{value}</StackItem>
        <IconButton
            size="small"
            icon={IconName.Copy}
            variant="ghost"
            onClick={() => copyInputToClipboard(value)}
            type="submit"
        />
    </Stack>
);
